<style lang="scss" scoped>
@import "./account.css";
.headerLogo {
    width: 12rem;
}
</style>

<template>
  <div :class="lan=='eng'?'content_eng':'content_big' " >
    <!-- <div class="title">{{parms.agreement_contents_title}}</div> -->
    <div style="text-align: center;background: #ffffff;border-bottom: 10px solid #eeeeee;margin-bottom: 1.5%;"  v-if="websta=='pc'&&this.$route.query.token">
      <img src="../../image/logoHeader.png" class="headerLogo">
    </div>
    <div :style="websta=='pc'&&this.$route.query.token?'padding: 0 25%;':''"  :class="websta=='pc'?'contentPc':'content' ">
      <div class="listTitle">
        <div class="pcTop" v-if="websta=='pc'"></div>
        <div style="font-weight: 600;color: #000;font-size: 15px;" v-if="websta=='pc'">{{parms.agreement_contents_title}}</div>
        <div v-for="(item,index) in parms.agreement_contents_List" :key="'info1'+index" :class="{shrink:!item.titlenum}"  @click="jump(index)" v-if="websta=='phone'">
            <span style="font-weight: 600;color: #000;" v-if="item.titlenum">{{item.titlenum}}</span>
            <span style="margin: 0 5px;" v-if="item.titlenum">–</span>
            <span>{{item.title}}</span>
        </div>
        <div v-for="(item,index) in parms.agreement_contents_List" :key="'info2'+index" :class="{shrinkPc:!item.titlenum}"  @click="jump(index)" v-if="websta=='pc'">
            <span style="font-weight: 600;color: #000;" v-if="item.titlenum">{{item.titlenum}}</span>
            <span style="margin: 0 5px;" v-if="item.titlenum">–</span>
            <span>{{item.title}}</span>
        </div>
        <div v-for="(item,index) in parms.agreement_contents_List" :key="'info3'+index" :class="{shrinkIpad:!item.titlenum}"  @click="jump(index)" v-if="websta=='ipad'">
            <span style="font-weight: 600;color: #000;" v-if="item.titlenum">{{item.titlenum}}</span>
            <span style="margin: 0 5px;" v-if="item.titlenum">–</span>
            <span>{{item.title}}</span>
        </div>

        <div @click="jump(9)" v-if="$route.query.token  && false">
          <span style="font-weight: 600;color: #000;">Part 6</span>
          <span style="margin: 0 5px;">–</span>
          <span>Signature Agreement</span>
        </div>
        <div @click="jump(9)" v-if="$route.query.token  &&  false">
          <span style="font-weight: 600;color: #000;">第六部份</span>
          <span style="margin: 0 5px;">–</span>
          <span>協議簽署</span>
        </div>
        <div class="marginTop list_1" v-for="(item,index) in parms.agreement_contents_text_List" :key="index" v-if="$route.query.token">
          <span style="width: 25px;flex-shrink: 0;" v-if="item.titlenum">{{item.titlenum}}</span>
          <span>{{item.title}}</span>
        </div>
        <div class="marginTop">{{parms.agreement_contents_text1}}</div>
        <div class="marginTop">{{parms.agreement_contents_text2}}</div>
      </div>
      <!-- 第一部分 -->
      <div class="part_1 box">
        <div class="marginTop firstPart_1">{{parms.agreement_part1_text1}}</div>
        <div class="marginTop" style="display:flex;">
          <span style="width:1.4rem;flex-shrink: 0;" v-if="parms.agreement_part1_text2">{{parms.agreement_part1_text2}}</span>
          <span>{{parms.agreement_part1_text3}}</span>
        </div>
        <table border="1" class="marginTop firstPart_2">
          <tr v-for="(item,index) in parms.agreement_part1_List" :key="index">
            <td :class="websta=='pc'?'firstPart_3Pc':'firstPart_3'">{{item.title}}</td>
            <td style="padding: 7px;" :colspan="2">{{item.text}}</td>
          </tr>
        </table>
        <div class="marginTop" style="display:flex;">
          <span style="width:1.4rem;flex-shrink: 0;" v-if="parms.agreement_part1_text4">{{parms.agreement_part1_text4}}</span>
          <span>{{parms.agreement_part1_text5}}</span>
        </div>
        <div v-for="(item,index) in parms.agreement_part1_1_2_List" :key="index" :style="websta=='pc'?'margin-left:1.4rem;':websta=='ipad'?'margin-left: 1.4rem;':'margin-left: 1.4rem;'"  style="display:flex;">
          <span style="width:1.4rem;flex-shrink: 0;" v-if="item.textnum">{{item.textnum}}</span>
          <span>{{item.text}}</span>
        </div>
      </div>
      <!-- 第二部分 -->
      <div  class="part_1 box">
        <div class="marginTop secondPart_1">{{parms.agreement_part2_text1}}</div>
        <div v-for="(item,index) in parms.agreement_part2_List" :key="index">
          <div class="secondPart_2" v-if="item.jibie == 1">
            <span :style="{width:websta=='pc'?'1.4rem':websta=='ipad'?'1.4rem':'1.5rem'}" style="flex-shrink: 0;text-align: center;" v-if="item.titlenum">{{item.titlenum}}</span>
            <span>{{item.title}}</span>
          </div>
          <div :class="websta=='pc'?'secondPart_3Pc':websta=='ipad'?'secondPart_3Ipad':'secondPart_3'" v-if="item.jibie == 2">
            <span :style="{width:websta=='pc'?'1.7rem':websta=='ipad'?'1.7rem':'2.5rem'}" style="flex-shrink: 0;" v-if="item.titlenum">{{item.titlenum}}</span>
            <span>{{item.title}}</span>
          </div>
          <div :class="websta=='pc'?'secondPart_4Pc':websta=='ipad'?'secondPart_4Ipad':'secondPart_4'" v-if="item.jibie == 3">
            <span style="width:1.4rem;flex-shrink: 0;" v-if="item.titlenum">{{item.titlenum}}</span>
            <span>{{item.title}}</span>
          </div>
          <div :class="websta=='pc'?'secondPart_5Pc':websta=='ipad'?'secondPart_5Ipad':'secondPart_5'" v-if="item.jibie == 4">
            <span :style="{width:websta=='pc'?'1.4rem':websta=='ipad'?'1.4rem':'1.7rem'}" style="flex-shrink: 0;" v-if="item.titlenum">{{item.titlenum}}</span>
            <span>{{item.title}}</span>
          </div>
        </div>
      </div>
      <!-- 第三部分 -->
      <div class="part_1 box">
          <div class="marginTop thirdPart_1">{{parms.agreement_part3_text1}}</div>
          <div v-for="(item,index) in parms.agreement_part3_List" :key="index">
            <div class="thirdPart_2 box" v-if="item.jibie == 1">
              <span style="width:30px;flex-shrink: 0;" v-if="item.titlenum">{{item.titlenum}}</span>
              <span>{{item.title}}</span>
            </div>
            <div class="thirdPart_3" v-if="item.jibie == 2">
              <span style="width:1.4rem;flex-shrink: 0;text-align: center;" v-if="item.titlenum">{{item.titlenum}}</span>
              <span>{{item.title}}</span>
            </div>
            <div :class="websta=='pc'?'thirdPart_4Pc':websta=='ipad'?'thirdPart_4Ipad':'thirdPart_4'" v-if="item.jibie == 3">
              <span style="width:1.7rem;flex-shrink: 0;" v-if="item.titlenum">{{item.titlenum}}</span>
              <span>{{item.title}}</span>
            </div>
            <div :class="websta=='pc'?'thirdPart_5Pc':websta=='ipad'?'thirdPart_5Ipad':'thirdPart_5'" v-if="item.jibie == 4">
              <span style="width:1.4rem;flex-shrink: 0;" v-if="item.titlenum">{{item.titlenum}}</span>
              <span>{{item.title}}</span>
            </div>
            <div :class="websta=='pc'?'thirdPart_6Pc':websta=='ipad'?'thirdPart_6Ipad':'thirdPart_6'" v-if="item.jibie == 5">
              <span style="width:1.5rem;flex-shrink: 0;" v-if="item.titlenum">{{item.titlenum}}</span>
              <span>{{item.title}}</span>
            </div>
          </div>
      </div>
      <!-- 第四部分 -->
      <div class="part_1 box">
          <div class="marginTop fourthPart_1">{{parms.agreement_part4_text1}}</div>
          <div v-for="(item,index) in parms.agreement_part4_List" :key="index">
            <div class="fourthPart_2" v-if="item.jibie == 1">
              <span :style="{width:websta=='pc'?'1.4rem':websta=='ipad'?'1.4rem':'1.5rem'}" style="flex-shrink: 0;text-align: center;" v-if="item.titlenum">{{item.titlenum}}</span>
              <span>{{item.title}}</span>
            </div>
            <div :class="websta=='pc'?'fourthPart_3Pc':websta=='ipad'?'fourthPart_3Ipad':'fourthPart_3'" v-if="item.jibie == 2">
              <span :style="{width:websta=='pc'?'2rem':websta=='ipad'?'2rem':'2.5rem'}" style="flex-shrink: 0;" v-if="item.titlenum">{{item.titlenum}}</span>
              <span>{{item.title}}</span>
            </div>
            <div :class="websta=='pc'?'fourthPart_4Pc':websta=='ipad'?'fourthPart_4Ipad':'fourthPart_4'" v-if="item.jibie == 3">
              <span style="width:1.4rem;flex-shrink: 0;" v-if="item.titlenum">{{item.titlenum}}</span>
              <span>{{item.title}}</span>
            </div>
            <div :class="websta=='pc'?'fourthPart_5Pc':websta=='ipad'?'fourthPart_5Ipad':'fourthPart_5'" v-if="item.jibie == 4">
              <span :style="{width:websta=='pc'?'1.4rem':websta=='ipad'?'1.4rem':'1.7rem'}" style="flex-shrink: 0;" v-if="item.titlenum">{{item.titlenum}}</span>
              <span>{{item.title}}</span>
            </div>
          </div>
      </div>
      <!-- 第五部分 -->
      <div class="part_1 box">
        <div class="marginTop fivePart_1">{{parms.agreement_part5_text1}}</div>
        <div v-for="(item,index) in  parms.agreement_part5_List" :key="index">
          <div class="fivePart_2" v-if="item.jibie == 1">
            <span style="width:1.4rem;flex-shrink: 0;text-align: center;" v-if="item.titlenum">{{item.titlenum}}</span>
            <span style="white-space: pre-line;">{{item.title}}</span>
          </div>
          <div :class="websta=='pc'?'fivePart_3Pc':websta=='ipad'?'fivePart_3Ipad':'fivePart_3'" v-if="item.jibie == 2">
            <span style="width:1.4rem;flex-shrink: 0;" v-if="item.titlenum">{{item.titlenum}}</span>
            <span>{{item.title}}</span>
          </div>
          <div :class="websta=='pc'?'fivePart_4Pc':websta=='ipad'?'fivePart_4Ipad':'fivePart_4'" v-if="item.jibie == 3">
            <span :style="{width:websta=='pc'?'1.4rem':websta=='ipad'?'1.4rem':'1.7rem'}" style="flex-shrink: 0;" v-if="item.titlenum">{{item.titlenum}}</span>
            <span>{{item.title}}</span>
          </div>
          <div :class="websta=='pc'?'fivePart_5Pc':websta=='ipad'?'fivePart_5Ipad':'fivePart_5'" v-if="item.jibie == 4">
            <span   style="width:1.4rem;flex-shrink: 0;" v-if="item.titlenum">{{item.titlenum}}</span>
            <span>{{item.title}}</span>
          </div>
        </div>
      </div>
      <!-- 第六部分 -->
      <div class="part_1 box" v-if="$route.query.token && false">
        <div class="marginTop fivePart_1">第六部份 – 協議簽署</div>
        <div style="font-weight: bold;">本協議書的締約方自上述第一個工作日起執行本協議書。</div>
        <div class="marginTop fivePart_1">公司資料</div>
        <div style="font-weight: bold;">為了及代表</div>
        <div style="font-weight: bold;">華亞證券有限公司</div>
        <div style="font-weight: bold;display: flex;margin-top: 10px;">
          <span :class="websta=='phone'?'sixPhone':websta=='ipad'?'sixIpad':'sixPc'">公司代表簽署 <span style="float: right; margin-right: 15px;">:</span></span>
          <div :class="websta=='phone'?'sixPhone_border':websta=='ipad'?'sixIpad_border':'sixPc_border'"></div>
        </div>
        <div style="font-weight: bold;display: flex;margin-top: 10px;">
          <span :class="websta=='phone'?'sixPhone':websta=='ipad'?'sixIpad':'sixPc'">公司代表名稱 (全寫及大楷) <span style="float: right; margin-right: 15px;">:</span></span>
          <div :class="websta=='phone'?'sixPhone_border':websta=='ipad'?'sixIpad_border':'sixPc_border'"></div>
        </div>
        <div style="font-weight: bold;display: flex;margin-top: 10px;">
          <span :class="websta=='phone'?'sixPhone':websta=='ipad'?'sixIpad':'sixPc'">職銜 <span style="float: right; margin-right: 15px;">:</span></span>
          <div :class="websta=='phone'?'sixPhone_border':websta=='ipad'?'sixIpad_border':'sixPc_border'"></div>
        </div>
        <div style="font-weight: bold;display: flex;margin-top: 10px;">
          <span :class="websta=='phone'?'sixPhone':websta=='ipad'?'sixIpad':'sixPc'">簽署日期 (日/月/年) <span style="float: right; margin-right: 15px;">:</span></span>
          <div :class="websta=='phone'?'sixPhone_border':websta=='ipad'?'sixIpad_border':'sixPc_border'"></div>
        </div>
        <div class="marginTop fivePart_1">客戶資料</div>
        <div style="font-weight: bold;display: flex;margin-top: 10px;">
          <span :class="websta=='phone'?'sixPhone':websta=='ipad'?'sixIpad':'sixPc'">客戶簽署<span style="float: right; margin-right: 15px;">:</span></span>
          <div :class="websta=='phone'?'sixPhone_border':websta=='ipad'?'sixIpad_border':'sixPc_border'"></div>
        </div>
        <div style="font-weight: bold;display: flex;margin-top: 10px;">
          <span :class="websta=='phone'?'sixPhone':websta=='ipad'?'sixIpad':'sixPc'">客戶名稱 (全寫及大楷)<span style="float: right; margin-right: 15px;">:</span></span>
          <div :class="websta=='phone'?'sixPhone_border':websta=='ipad'?'sixIpad_border':'sixPc_border'"></div>
        </div>
        <div style="font-weight: bold;display: flex;margin-top: 10px;">
          <span :class="websta=='phone'?'sixPhone':websta=='ipad'?'sixIpad':'sixPc'">客戶身份證 / 護照號碼<span style="float: right; margin-right: 15px;">:</span></span>
          <div :class="websta=='phone'?'sixPhone_border':websta=='ipad'?'sixIpad_border':'sixPc_border'"></div>
        </div>
        <div style="font-weight: bold;display: flex;margin-top: 10px;">
          <span :class="websta=='phone'?'sixPhone':websta=='ipad'?'sixIpad':'sixPc'">簽署日期 (日/月/年)<span style="float: right; margin-right: 15px;">:</span></span>
          <div :class="websta=='phone'?'sixPhone_border':websta=='ipad'?'sixIpad_border':'sixPc_border'"></div>
        </div>


      </div>
    </div>
    <div class="addTop_pc" @click="goTopPcClick(0)" v-if="websta=='pc'">
      <img src="../../image/top.png" alt="">
    </div>
    <div class="addTop" @click="goTopClick()" v-else>
      <img src="../../image/top.png" alt="">
    </div>
  </div>
</template>
<script>
import https from "@/plugins/http.js";

import apiUrl from "@/assets/api.js";

import App from "@/assets/app.js";

export default {
  data() {
    return {
      websta: sessionStorage["onlinestate"],
      parms:{},
      lan:"",

    };
  },
  mounted() {
    this.websta =  sessionStorage["onlinestate"]?sessionStorage["onlinestate"]:'pc';
    this.lan = this.$route.query.lan?this.$route.query.lan:this.$i18n.locale;
    console.log(this.lan);
    if (this.lan == 'eng') {
        document.title = 'Agreement for Securities Trading Account';
    }else{
      if (this.lan == 'eng') {
      document.title = '證券交易帳戶協議書';
      }
    }
    console.log(this.$route);
    this.agreeEvent();
  },

  methods: {
    agreeEvent() {
      var url;
      if(location.protocol == 'https:') {
        url = 'https://www.qmisgroup.com:2347/groupweb/getAgreeMentOfKHPage'
      }else{
        url = 'https://www.qmisgroup.com:2347/groupweb/getAgreeMentOfKHPage'
        // url = 'http://202.130.113.149:2346/groupweb/getAgreeMentOfKHPage'
      }
      // url = 'https://hk.qmisit.com:3785/talk/getAgreeMentOfKHPage'
      https.fetchLoginPost(url, {
          lan:!this.lan?'big5':this.lan,
          usertoken:this.$route.query.token
        })
        .then((data) => {
          if (Object.is(data.qmiscode, 1000)) {
            this.parms = data
            console.log(this.parms);
          } else {
            App.oTool.warningT(data.qmismsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 目录锚点
    jump(index){
      console.log(index);
      var items = document.querySelectorAll(".box");
      for (var i = 0; i < items.length; i++) {
        if (index === i) {
          items[i].scrollIntoView({
            block: "start",//默认跳转到顶部
            behavior: "smooth"//滚动的速度
          });
        }
      }
    },
    // 点击置顶
    goTopClick(){
      console.log("点击置顶1");
      document.documentElement.scrollIntoView({ behavior: "smooth" });
    },
    // 点击置顶
    goTopPcClick(index){
      console.log("点击置顶");
      var items = document.querySelectorAll(".pcTop");
      for (var i = 0; i < items.length; i++) {
        if (index === i) {
          items[i].scrollIntoView({
            block: "start",//默认跳转到顶部
            behavior: "smooth"//滚动的速度
          });
        }
      }
    }

  },
};
</script>


